<template>
    <div>
            <div>
                <span v-if="$i18n.locale == 'ru'">
                    <p class="pr-0">
                        Программное обеспечение распространяется по модели SaaS (Software as a Service).
                        Благодаря системе подписок можно быстро приступить к работе без необходимости установки программы на вашем компьютере.
                        Вы не привязаны к какой-либо определенной операционной системе или рабочему компьютеру. Всё, что вам нужно — это современная версия браузера и доступ в Интернет.
                    </p>
                    <p class="pr-0">
                        Список подписок с условиями и ценами за различные периоды времени представлены в таблице. <b>Ознакомительная подписка с ограничениями использования программы доступна сразу после регистрации и авторизации в веб-сервисе.</b>
                        Подключить подписку можно после авторизации в разделе «Моя подписка». Оплата доступна тремя способами:
                        <ul>
                            <li>Банковской картой</li>
                            <li>Через систему быстрых платежей</li>
                            <li>Запрос счёта на оплату</li>
                        </ul>
                        Подключение подписки и открытие полного доступа к сервису происходит после успешного платежа.
                    </p>
                </span>
                <span v-else>
                    <p class="pr-0">
                        The software is distributed under the SaaS (Software as a Service) model.
                        Subscription system allows you to get started quickly without having to install the program on your computer.
                        You are not tied to any particular operating system or computer. All you need for work - is a modern version of the browser and internet access.
                        </p>
                    <p class="pr-0">
                        The list of tariffs with conditions and prices for different time periods is presented in the table. <b>The trial tariff with restrictions on the use of the program is available immediately after registration and authorization in the web service.</b>
                        You can activate a subscription after authorization in the "My subscription" section. Payment is available in three ways:
                        <ul>
                            <li>By bank card</li>
                            <li>Through the fast payment system</li>
                            <li>Request for payment invoice</li>
                        </ul>
                        The subscription is activated and full access to the service is opened after a successful payment.
                    </p>
                </span>
            </div>

            <v-layout align-center justify-center style="overflow: auto;" class="!v-scrollable!">
                <v-flex>
                    <table class="table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>{{ $t("subscriptionPlans.free") }} <sup>*</sup></th>
                                <th>{{ $t("subscriptionPlans.standard") }}</th>
                                <th>{{ $t("subscriptionPlans.standardPlus") }}</th>
                                <th>{{ $t("subscriptionPlans.professional") }}</th>
                            </tr>
                            <tr>
                                <th>{{ $t("subscriptionPlans.quarterly") }}</th>
                                <th>-</th>
                                <th>{{ $config.prices.standard.quarter.num }} {{ $t("subscriptionPlans.currency") }}</th>
                                <th>{{ $config.prices.standardPlus.quarter.num }} {{ $t("subscriptionPlans.currency") }}</th>
                                <th>{{ $config.prices.professional.quarter.num }} {{ $t("subscriptionPlans.currency") }}</th>
                            </tr>
                            <tr>
                                <th>{{ $t("subscriptionPlans.yearly") }}</th>
                                <th>-</th>
                                <th>{{ $config.prices.standard.year.num }} {{ $t("subscriptionPlans.currency") }}</th>
                                <th>{{ $config.prices.standardPlus.year.num }} {{ $t("subscriptionPlans.currency") }}</th>
                                <th>{{ $config.prices.professional.year.num }} {{ $t("subscriptionPlans.currency") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="subheader">
                                <td>{{ $t("subscriptionPlans.availableFeatures") }}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr
                                v-for="(item, index) in $t('subscriptionPlans.features')"
                                :key="index"
                            >
                                <td class="text-xs-left">{{ item }}</td>
                                <td><v-icon v-if="![0, 5, 9, 12, 13].includes(index)">mdi-check</v-icon></td>
                                <td><v-icon v-if="index < 9">mdi-check</v-icon></td>
                                <td><v-icon v-if="index < 10">mdi-check</v-icon></td>
                                <td><v-icon>mdi-check</v-icon></td>
                            </tr>
                            <tr class="subheader">
                                <td>{{ $t("subscriptionPlans.restrictions") }}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td class="text-xs-left">{{ $t("subscriptionPlans.usersAmount") }}</td>
                                <td>1</td>
                                <td>1</td>
                                <td>3</td>
                                <td><v-icon>mdi-infinity</v-icon></td>
                            </tr>
                            <tr>
                                <td class="text-xs-left">{{ $t("subscriptionPlans.patternsAmount") }}</td>
                                <td>2</td>
                                <td>50</td>
                                <td>200</td>
                                <td><v-icon>mdi-infinity</v-icon></td>
                            </tr>
                            <tr>
                                <td class="text-xs-left">{{ $t("subscriptionPlans.modelsAmount") }}</td>
                                <td>1</td>
                                <td>50</td>
                                <td>200</td>
                                <td><v-icon>mdi-infinity</v-icon></td>
                            </tr>
                            <tr>
                                <td class="text-xs-left">{{ $t("subscriptionPlans.sawProfilesAmount") }}</td>
                                <td>1</td>
                                <td>1</td>
                                <td>2</td>
                                <td><v-icon>mdi-infinity</v-icon></td>
                            </tr>
                        </tbody>
                    </table>

                </v-flex>
            </v-layout>

            <span v-if="$store.getters.subscription.id == null">
                <p><sup>*</sup> {{ $t("notes.trialAvailability") }}</p>
            </span>
        </div>
</template>

<script>
    export default {
        name: "TariffsTable",

        props: [ "isFlat" ],
    }
</script>

<style lang="sass" scoped>
    .layout.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100vh - 128px)

    .application
        &.theme--dark
            .table
                thead
                    tr
                        background: #404040
                tbody
                    tr.subheader
                        background: #004d40
        &.theme--light
            .table
                thead
                    tr
                        background: #f9f9f9
                tbody
                    tr.subheader
                        background: #dbefdd

    .table
        margin-top: 16px
        margin-bottom: 8px
        height: 100%
        width: 100%
        min-width: 1000px
        text-align: center
        border-spacing: 0
        border: 1px solid #c4c1c1
        border-right: 0
        border-top: 0
        td, th
            padding: 2px
            height: 25px
            border: 1px solid #c4c1c1
            border-bottom: 0
            border-left: 0
        thead
            tr
                font-weight: bold
                th:nth-child(n+2)
                    width: 140px
                &:first-child
                    height: 40px
            tr:nth-child(n+2)
                height: 35px
                th
                    font-weight: normal
                th:first-child
                    text-align: right
                    padding-right: 12px

        tbody
            tr.subheader
                height: 40px
                font-weight: bold
</style>
